import seniorLivingCareStaff from "./responses/senior_living_care_staff.json";
import seniorLivingCareManager from "./responses/senior_living_care_manager.json";
import rehabAide from "./responses/rehab_aide.json";
import rehabPtOt from "./responses/rehab_pt_ot.json";
import primaryCareTeam from "./responses/primary_care_team.json";
import primaryCarePhysician from "./responses/primary_care_physician.json";
import homeCareCaregiver from "./responses/home_care_caregiver.json";
import homeCareCareManager from "./responses/home_care_care_manager.json";
import pharmacyPharmacist from "./responses/pharmacy_pharmacist.json";

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

const TENANT_ALIASES = {
  sl: "senior_living",
  seniorliving: "senior_living",
  pcp: "primary_care",
  primarycare: "primary_care",
  hc: "home_care",
  homecare: "home_care",
  fp: "pharmacy",
  familiprix: "pharmacy",
};

const ROLE_ALIASES = {
  care_staff: "carestaff",
  care_manager: "caremanager",
  pt: "pt_ot",
  careteam: "care_team",
};

const RESPONSES = {
  senior_living: {
    carestaff: seniorLivingCareStaff,
    caremanager: seniorLivingCareManager,
  },
  rehab: {
    rehab_aide: rehabAide,
    pt_ot: rehabPtOt,
  },
  primary_care: {
    care_team: primaryCareTeam,
    physician: primaryCarePhysician,
  },
  home_care: {
    caregiver: homeCareCaregiver,
    caremanager: homeCareCareManager,
  },
  pharmacy: {
    pharmacist: pharmacyPharmacist,
  },
};

const DEFAULT_ROLES = {
  senior_living: "carestaff",
  rehab: "rehab_aide",
  primary_care: "care_team",
  home_care: "caregiver",
  pharmacy: "pharmacist",
};

/**
 * Human labels for the persona switch tab. Keyed by tenant → role. The
 * backend resolves which persona a real user sees; this map is only for the
 * demo switcher (and as a fallback label).
 */
const PERSONA_LABELS = {
  senior_living: { carestaff: "Care Staff", caremanager: "Care Manager" },
  rehab: { rehab_aide: "Rehab Aide", pt_ot: "PT / OT" },
  primary_care: { care_team: "Care Team", physician: "Physician" },
  home_care: { caregiver: "Caregiver", caremanager: "Care Manager" },
  pharmacy: { pharmacist: "Pharmacist" },
};

/** Personas available for a tenant, in display order: [{ key, label }]. */
export const getPersonasForTenant = (tenantType) => {
  const tenant = resolveTenantType(tenantType);
  const labels = PERSONA_LABELS[tenant] || {};
  return Object.keys(RESPONSES[tenant] || {}).map((key) => ({
    key,
    label: labels[key] || key,
  }));
};

export const resolveTenantType = (value) => {
  const normalized = normalize(value);
  return TENANT_ALIASES[normalized] || normalized || "home_care";
};

export const resolveUserType = (tenantType, value) => {
  const normalized = normalize(value);
  return (
    ROLE_ALIASES[normalized] ||
    normalized ||
    DEFAULT_ROLES[resolveTenantType(tenantType)]
  );
};

export const getMockActionPlan = (tenantType, userType) => {
  const tenant = resolveTenantType(tenantType);
  const role = resolveUserType(tenant, userType);
  return (
    RESPONSES[tenant]?.[role] ||
    RESPONSES[tenant]?.[DEFAULT_ROLES[tenant]] ||
    homeCareCaregiver
  );
};
